import {
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableHead,
  TableCell,
} from '@/components/ui/table';
import { Skeleton } from '@/components/ui/skeleton';
import type { IPolicyBreakdownItem } from '@/@types/superadmin';

interface IPolicyBreakdownTableProps {
  breakdown: IPolicyBreakdownItem[] | undefined;
  isLoading: boolean;
} // LOCAL_TYPE_JUSTIFIED: component props

export function PolicyBreakdownTable({ breakdown, isLoading }: IPolicyBreakdownTableProps) {
  if (isLoading)
    return (
      <div className="space-y-2">
        {[...Array(4)].map((_, i) => (
          <div key={i} className="flex gap-4 px-4 py-2">
            <Skeleton className="h-4 w-32" />
            <Skeleton className="h-4 w-28" />
            <Skeleton className="h-4 w-12" />
          </div>
        ))}
      </div>
    );
  if (!breakdown || breakdown.length === 0)
    return <p className="text-sm text-muted-foreground px-4 py-6 text-center">No policies found</p>;
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Policy Type</TableHead>
          <TableHead>Provider</TableHead>
          <TableHead className="text-right">Count</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {breakdown.map((item, idx) => (
          <TableRow key={idx}>
            <TableCell className="font-medium">{item.policyTypeName}</TableCell>
            <TableCell>{item.providerName}</TableCell>
            <TableCell className="text-right">{item.count}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
